import { Box, Button, Grid, Tooltip, Typography } from '@mui/material';
import Alert from '@mui/material/Alert';
import Update from 'mdi-material-ui/Update';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { apiService } from '../../api/axiosClient';
import Page from '../../components/Page';
import PageHeader from '../../components/page-header';
import Spinner from '../../components/spinner';
import BoxWrapper from '../../styles/BoxWrapper';
import CategoryWrapper from '../../views/section_category/CategoryWrapper';

const CategorySectionList = () => {
    const [loading, setLoading] = useState(true)
    const [items, setItems] = useState([])

    useEffect(() => {
        const fetchData = async () => {
            const response = await apiService.get('/category_section')
            const payload = response.data;
            setItems(payload.list)
            setLoading(false)
        }

        fetchData().catch((error) => {
            console.error(error)
        });
    }, [])

    const keywordUpdate = async () => {
        await apiService.put('/category_section')
        .then(response => {
            toast.success('업데이트 되었습니다.')
        }).catch(error => {
            // 에러는 이제 axiosClient의 interceptor에서 자동으로 처리됩니다
            console.error('API Error:', error);
        });
    }

    const updateHandler = (e) => {
        keywordUpdate();        
    }

    return (
        loading ?
        <Spinner/>
        :
        <Page title="Category Section">
            <Grid container spacing={6}>
                <PageHeader
                    title={
                        <Typography variant='h5' color='#666CFF'>
                        카테고리 관리
                        </Typography>
                    }
                    subtitle={
                        <Box>
                            <Typography variant='body2'>
                            카테고리 메뉴별 이미지 설정, 상품 검색페이지에서 배너이미지 설정, 홈페이지에서 추천 카테고리별 노출을 제어합니다.
                            </Typography>
                            <Alert severity='info' sx={{mt:2}}>
                                상품 카테고리 수정 및 추가시 업데이트 버튼으로 갱신하세요
                            </Alert>
                        </Box>
                    }
                />
                <BoxWrapper>
                    <Tooltip title="입력된 카테고리 데이타를 이용 키워드 자동 업데이트">
                        <Button variant='contained' startIcon={<Update />} onClick={updateHandler} >키워드 업데이트</Button>
                    </Tooltip>
                </BoxWrapper>
                <Grid item xs={12}>
                    {items.length > 0 ? (
                        <CategoryWrapper items={items} />
                    ) : (
                        <Alert severity='warning'>카테고리 데이타가 없습니다</Alert>
                    )}
                </Grid>
            </Grid>
        </Page>
    )
}

export default CategorySectionList